module.exports = __webpack_public_path__ + "images/Add_hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Add_hover.png
// module id = 382
// module chunks = 0 1